import React from 'react';

const STATUS_STYLES = {
  translated: 'bg-emerald-500/10 text-emerald-600',
  partial: 'bg-yellow-500/10 text-yellow-600',
  missing: 'bg-destructive/10 text-destructive',
  outdated: 'bg-orange-500/10 text-orange-600',
  completed: 'bg-emerald-500/10 text-emerald-600',
  in_progress: 'bg-primary/10 text-primary',
  pending: 'bg-muted text-muted-foreground',
  failed: 'bg-destructive/10 text-destructive',
};

export default function StatusBadge({ status }) {
  if (!status) return null;
  const style = STATUS_STYLES[status] || 'bg-muted text-muted-foreground';
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium ${style}`}>
      {status.replace('_', ' ')}
    </span>
  );
}
